/* ORYX App 2.0
 *
 * Created by ORYX Movement Solutions © 2022
 * ==================================================================
 *
 * Homepage.
 */

import { IonCol, IonContent, IonFooter, IonGrid, IonImg, IonPage, IonRow } from '@ionic/react';

import styles from '@/pages/Login/Login.module.css';

import { Button } from '@/components/Button';
import { LoginForm } from '@/components/Forms/loginForm';
import { NewPasswordForm } from '@/components/Forms/newPasswordForm';
import { ResetPasswordForm } from '@/components/Forms/ResetPasswordForm';
import { IconRotate } from '@/components/Icon/types';

import LoginBackgroundShape from '@/assets/login/login_bg_shape.svg';

const PageLayout = ({
  showBackButton,
  formComponent,
}: {
  showBackButton?: boolean;
  formComponent: React.ReactNode;
}) => {
  return (
    <IonPage className={styles.page}>
      <IonContent className={styles.wrapper} fullscreen>
        {showBackButton && (
          <Button
            className={styles.back}
            href='/'
            leadingIcon='chevron'
            leadingIconDirection={IconRotate.West}
            size='medium'
            variant='tertiary'>
            Back
          </Button>
        )}

        <IonGrid class={styles.grid}>
          <IonRow class='ion-align-items-center'>
            <IonCol class='ion-justify-content-center'>{formComponent}</IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>

      <IonFooter className={styles.footer}>
        <Button
          className={styles.privacyPolicy}
          href='https://oryxmovementsolutions.com/privacy'
          size='small'
          target='_blank'
          variant='tertiary'>
          Privacy Policy
        </Button>
      </IonFooter>
      <IonImg className={styles.background} src={LoginBackgroundShape} />
    </IonPage>
  );
};

export const LoginPage: React.FC = () => {
  return <PageLayout formComponent={<LoginForm />} />;
};

export const ResetPasswordPage: React.FC = () => {
  return <PageLayout formComponent={<ResetPasswordForm />} showBackButton />;
};

export const NewPasswordPage: React.FC = () => {
  return <PageLayout formComponent={<NewPasswordForm />} showBackButton />;
};
